const Palette = {
  HihiBlack: "#070604",
  HihiYellow: "#F9E211",
  HihiDarkGrey: "#797A87",
  HihiLightGrey: "#A8ACAD",
  HihiPastelBrown: "#D6CBB5",
  HoihoLavender: "#CABEE9",
  HoihoDarkGrey: "#7C7189",
  HoihoYellow: "#FAE093",
  HoihoRed: "#D04E59",
  HoihoPastelBrown: "#BC8E7D",
  HoihoDarkBlue: "#2F3D70",
  KākāRed: "#A7473A",
  KākāDarkGrey: "#4B5F6C",
  KākāOlive: "#B09B37",
  KākāBrown: "#955F47",
  KākāLightGrey: "#A8B9CB",
  KākāpōDarkGreen: "#7D9D33",
  KākāpōLightGreen: "#CED38C",
  KākāpōYellow: "#DCC949",
  KākāpōPastelBrown: "#BCA888",
  KākāpōPastelOrange: "#CD8862",
  KākāpōDarkBrown: "#775B24",
  KākārikiDarkGreen: "#44781E",
  KākārikiLightGreen: "#A1B654",
  KākārikiDarkBlue: "#2C3B75",
  KākārikiRed: "#B8321A",
  KākārikiDarkGrey: "#565052",
  KeaDarkGreen: "#6C803A",
  KeaDarkBrown: "#7B5C34",
  KeaLightBrown: "#AB7C47",
  KeaYellowBrown: "#CCAE42",
  KeaRed: "#D73202",
  KeaBlack: "#272318",
  KeaLightGrey: "#D3CDBF",
  KererūDarkGreen: "#325756",
  KererūPink: "#C582B2",
  KererūGreen: "#51806a",
  KererūDarkBlue: "#4d5f8e",
  KererūLavender: "#A092B7",
  KorimakoGreen: "#757b16",
  KorimakoDarkGreen: "#4F651D",
  KorimakoGrey: "#798C8B",
  KorimakoBlue: "#2F638F",
  KorimakoBlack: "#091A26",
  KorimakoDarkBrown: "#490B0A",
  KororāLightBlue: "#85BEDC",
  KororāBlack: "#3A383F",
  KororāLightGrey: "#A6B0BB",
  KororāMauve: "#CCBBCD",
  KororāDarkGrey: "#647588",
  KōtareDarkBlue: "#214d65",
  KōtareLightBlue: "#287DAB",
  KōtareSandBrown: "#E5BF86",
  KōtareLightBrown: "#B09771",
  KōtareDarkBrown: "#624B27",
  KōtareLightGrey: "#CACFD0",
  PūtangitangiLightGrey: "#AA988A",
  PūtangitangiLightBrown: "#B66A40",
  PūtangitangiDarkBlue: "#2F414B",
  PūtangitangiDarkGreen: "#2B4B3C",
  PūtangitangiDarkBrown: "#7A3520",
  PūtangitangiBlueGrey: "#7B8BA5",
  TakahēRed: "#DD3C51",
  TakahēDarkBlue: "#313657",
  TakahēTeal: "#1F6683",
  TakahēLightBlue: "#6C90B9",
  TakahēWarmGrey: "#D1C7B5",
  TakapuLightBrown: "#DEB478",
  TakapuDarkBrown: "#976533",
  TakapuLightGrey: "#D3D5D0",
  TakapuDarkGrey: "#76716E",
  TakapuBlack: "#272623",
  TitipounamuBlack: "#3E4331",
  TitipounamuBrown: "#AD6B17",
  TitipounamuDarkGreen: "#66743B",
  TitipounamuLightGreen: "#D0C471",
  TitipounamuYellow: "#CCB62F",
  TitipounamuLightGrey: "#BAC4C2",
  TūīLightBlue: "#7ACCD7",
  TūīDarkBlue: "#115896",
  TūīWarmGrey: "#7C6C65",
  TūīDarkGrey: "#4C4C53",
  TūīRed: "#BA2F00",
  TūīBlack: "#21282F",
  PepetunaLightGreen: "#719E56",
  PepetunaDarkGreen: "#71702F",
  PepetunaLightBrown: "#947163",
  PepetunaDarkBrown: "#623711",
  PepetunaDarkGrey: "#425266",
  PōhutukawaLightBlue: "#5FA1F7",
  PōhutukawaLightGreen: "#83A552",
  PōhutukawaDarkGreen: "#3D4928",
  PōhutukawaRed: "#9B1F1A",
  PōhutukawaLightBrown: "#B19F8E",
  PōhutukawaDarkBrown: "#4E0B0C"
}

export default Palette;
